import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const Historics = ({ historics, onBack }) => {
    // Reverse the list to display latest first
    const reversedHistorics = historics ? [...historics].reverse() : [];

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Back control consistent with GameRules */}
            <button
                aria-label="Retour"
                onClick={onBack}
                style={{
                    alignSelf: "flex-start",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                    background: "transparent",
                    color: "#fff",
                    border: "none",
                    fontSize: 16,
                    fontWeight: 600,
                    cursor: "pointer",
                    padding: 8,
                    borderRadius: 8,
                }}
            >
                <ArrowBackIosNewIcon fontSize="small" />
                Retour
            </button>

            <div style={{ flex: 1, overflowY: 'auto', paddingRight: 5 }}>
                {reversedHistorics.map((item, index) => {
                    if (item.type === 'CHOICE') {
                        return (
                            <div key={index} style={{
                                width: '100%',
                                padding: 15,
                                marginBottom: 12,
                                borderRadius: 14,
                                background: 'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.03))',
                                boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
                                boxSizing: 'border-box',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 4
                            }}>
                                <div style={{
                                    fontWeight: 'bold',
                                    color: item.playerColor || '#fff',
                                    fontSize: '0.9em'
                                }}>
                                    {item.playerName}
                                </div>
                                <div style={{ color: '#fff', fontSize: '1em' }}>
                                    {item.message}
                                </div>
                            </div>
                        );
                    } else {
                        // EFFECT
                        return (
                            <div key={index} style={{
                                marginBottom: 8,
                                padding: '4px 0',
                                color: '#ddd',
                                fontSize: '0.95em'
                            }}>
                                <span style={{ fontWeight: 'bold', color: item.playerColor || '#fff' }}>
                                    {item.playerName}
                                </span>
                                <span style={{ margin: '0 4px' }}>-</span>
                                <span>{item.message}</span>
                            </div>
                        );
                    }
                })}
                {reversedHistorics.length === 0 && (
                    <div style={{ textAlign: 'center', color: 'rgba(255,255,255,0.5)', marginTop: 20 }}>
                        Aucun historique disponible.
                    </div>
                )}
            </div>
        </div>
    );
};

export default Historics;

